import { useAppDispatch, useAppSelector } from "../../hooks"
import {
  searchQuery as searchQueryStored,
  setSearchQuery
} from "../../../redux/slices/conversations"
import { Threads } from "../../../types"
import ConversationsBrandSelector from "../conversations-brand-selector"
import SearchInput from "../form/search-input"
import List from "./list"
import ConversationFilter from "../conversation-filter"
import ConversationsStats from "../conversations-stats"
import ConversationsDateFilter from "../conversations-date-filter"

interface Props {
  filteredThreads: Threads
  isLoading: boolean
  hasMore: boolean
  loadMore: () => void
  isLoadingMore: boolean
}

const ConversationsList = ({
  filteredThreads,
  isLoading,
  hasMore,
  loadMore,
  isLoadingMore
}: Props) => {
  const dispatch = useAppDispatch()
  const searchQuery = useAppSelector(searchQueryStored)

  return (
    <div className="flex flex-col flex-1 h-full bg-white">
      <div className="shrink-0 border-b border-neutral-200 bg-white z-10">
        <div className="p-4">
          <div className="flex items-center gap-3">
            <SearchInput
              disabled={isLoading}
              className="py-2"
              wrapperClassName="w-full"
              placeholder="Search Leads"
              value={searchQuery}
              onSearch={val => dispatch(setSearchQuery(val as string))}
            />
            <ConversationFilter />
          </div>
          <ConversationsBrandSelector />
          <div className="mt-3">
            <ConversationsDateFilter />
          </div>
        </div>
        <ConversationsStats />
      </div>

      <div className="flex-1 overflow-y-auto">
        <List
          isLoading={isLoading}
          filteredThreads={filteredThreads}
          hasMore={hasMore}
          loadMore={loadMore}
          isLoadingMore={isLoadingMore}
        />
      </div>
    </div>
  )
}

export default ConversationsList
